"use client";

import { MessageCircle } from "lucide-react";

const WHATSAPP_URL = "https://wa.me/6285975124638";

export function WhatsAppButton() {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-[65] flex h-16 w-16 items-center justify-center rounded-full border-2 border-white bg-[#25D366] text-white shadow-[0_8px_24px_rgba(37,211,102,0.35)] transition-transform hover:scale-105"
    >
      <MessageCircle className="h-8 w-8" />
    </a>
  );
}
